import { DOCUMENT } from '@angular/common';
import {
  afterNextRender,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  input,
  output,
} from '@angular/core';
import { AdminIconComponent } from './admin-icon.component';

@Component({
  selector: 'app-admin-modal',
  standalone: true,
  imports: [AdminIconComponent],
  template: `
    <div class="cg-modal-backdrop" (click)="closed.emit()" role="presentation">
      <div
        class="cg-modal cg-animate-rise-in cg-admin-modal-panel"
        [class.cg-admin-modal-panel--lg]="size() === 'lg'"
        [class.cg-admin-modal-panel--xl]="size() === 'xl'"
        [class.cg-admin-modal-panel--2xl]="size() === '2xl'"
        [class.cg-admin-modal-panel--workflow-doc]="size() === 'workflow-doc'"
        [class.cg-admin-modal-panel--lead-import]="variant() === 'lead-import'"
        (click)="$event.stopPropagation()"
        role="dialog"
        aria-modal="true"
        [attr.aria-labelledby]="title() ? titleId() : null"
      >
        <div class="cg-admin-modal-panel__header">
          @if (title()) {
            <h2 [id]="titleId()" class="cg-section-title cg-admin-modal-panel__title">{{ title() }}</h2>
          }
          <button
            type="button"
            class="cg-admin-modal-panel__close"
            aria-label="Close dialog"
            (click)="closed.emit()"
          >
            <app-admin-icon name="x" [size]="18" />
          </button>
        </div>
        <ng-content />
      </div>
    </div>
  `,
  styles: `
    :host {
      display: contents;
    }
  `,
})
export class AdminModalComponent {
  private readonly host = inject(ElementRef<HTMLElement>);
  private readonly doc = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);

  readonly title = input<string>();
  readonly titleId = input('admin-modal-title');
  readonly size = input<'md' | 'lg' | 'xl' | '2xl' | 'workflow-doc'>('md');
  readonly variant = input<'default' | 'lead-import'>('default');
  readonly closed = output<void>();

  constructor() {
    afterNextRender(() => {
      const el = this.host.nativeElement;
      this.doc.body.appendChild(el);
      this.destroyRef.onDestroy(() => el.remove());
    });
  }
}
